var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCornerArrowWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "corner-up-right-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33347 6.66687L3.33337 12.6668H4.66671L4.66678 8.0002L11.448 8.00013L8.81484 10.6333L9.75764 11.5761L14.0003 7.33347L9.75764 3.09082L8.81484 4.03363L11.448 6.6668L3.33347 6.66687Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerArrowWhite);
export default __webpack_public_path__ + "static/media/corner-arrow-white.c3f6ce5c081670459cd4e220913e4741.svg";
export { ForwardRef as ReactComponent };